import { z } from "zod";
import { isAddress } from "viem";

const ethereumAddressSchema = z.string().refine(
  (address) => {
    return isAddress(address) || address.endsWith(".eth");
  },
  {
    message: "Invalid Ethereum address",
  },
);

export const airdropSchema = z.object({
  walletAddress: ethereumAddressSchema,
});
